import { Injectable } from "@angular/core";
import { LocalStorageService } from "./local-storage.service";
import { UserDto } from "../../dtos/user-dto";
import { HttpHeaders } from "@angular/common/http";


@Injectable()
export class IdentityService {

    constructor(private localStorage: LocalStorageService) { }

    getUserLogued(): UserDto {
        let user: UserDto = new UserDto();
        let current = this.getLocalStorage();
        if (current) {
            user = JSON.parse(current);
        }
        return user;
    }

    getToken(): HttpHeaders {
        let currentUser = this.getUserLogued();
        let headers = new HttpHeaders();
        console.dir(currentUser);
        if (currentUser.token) {
            headers = new HttpHeaders({
                'Authorization': 'Bearer ' + currentUser.token, 'IdCU': currentUser.id.toString(), 'CurrentUser': encodeURI(currentUser.username), 'auth': currentUser.auth.toString(), 'plants': encodeURI(currentUser.username+'B')
            });
        }
        return headers;
    }

    getLocalStorage() {
        let storage: any = "";
        if (this.localStorage) {
            storage = this.localStorage.getLocalStorage('currentUser');
        }
        return storage;
    }

    setLocalStorage(value: any) {
        if (this.localStorage) {
            this.localStorage.setLocalStorage('currentUser', value);
        }
    }

    removeLocalStorage() {
        if (this.localStorage) {
            this.localStorage.removeLocalStorage('currentUser');
        }
    }

    addLocalStorageByKey(key: string, value: any) {
        if (this.localStorage) {
            this.localStorage.setLocalStorage(key, value);
        }
    }

    removeLocalStorageByKey(key: string) {
        if (this.localStorage) {
            this.localStorage.removeLocalStorage(key);
        }
    }

    getLocalStorageByKey(key: string) {
        return this.localStorage.getLocalStorage(key);
    }
}
